import { createSelector, MemoizedSelector } from '@ngrx/store';

import { selectAuthState } from '../core.state';
import { IAuthState } from './auth.models';
export const selectAuth: MemoizedSelector<object, IAuthState> = createSelector(selectAuthState, (state: IAuthState) => state);
export const selectIsAuthenticated: MemoizedSelector<object, boolean> = createSelector(selectAuthState, (state: IAuthState) => state.isAuthenticated);
